// extracted by mini-css-extract-plugin
export default {"tag":"current-filter-tag_tag__sQxDE","labelPrefix":"current-filter-tag_labelPrefix__QkHR7"};